import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingPurchaseOrderCreateView from 'src/sections/packaging-purchase-order/view/packaging-purchase-order-create-view';

export default function PackagingPurchaseOrderCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new packaging purchase order</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_PACKAGING_PURCHASE_ORDER,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingPurchaseOrderCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
